import '../ui-anchor/ui-anchor.en';
import '../ui-annotation/ui-annotation.en';
import '../ui-assets/ui-assets.en';
import '../ui-autocomplete/ui-autocomplete.en';
import '../ui-breadcrumbs/ui-breadcrumbs.en';
import '../ui-button/ui-button.en';
import '../ui-calendar/ui-calendar.en';
import '../ui-chip/ui-chip.en';
import '../ui-comparison-cards/ui-comparison-cards.en';
import '../ui-countdown/ui-countdown.en';
import '../ui-curtain/ui-curtain.en';
import '../ui-datepicker/ui-datepicker.en';
import '../ui-daterange/ui-daterange.en';
import '../ui-dialogbubble/ui-dialogbubble.en';
import '../ui-dropdown/ui-dropdown.en';
import '../ui-feedback/ui-feedback.en';
import '../ui-field/ui-field.en';
import '../ui-footer/ui-footer.en';
import '../ui-form/ui-form.en';
import '../ui-message/ui-message.en';
import '../ui-modal/ui-modal.en';
import '../ui-monthpicker/ui-monthpicker.en';
import '../ui-nav/ui-nav.en';
import '../ui-navitem/ui-navitem.en';
import '../ui-navlist/ui-navlist.en';
import '../ui-navtoggle/ui-navtoggle.en';
import '../ui-offer/ui-offer.en';
import '../ui-salesribbon/ui-salesribbon.en';
import '../ui-pagination/ui-pagination.en';
import '../ui-phonefield/ui-phonefield.en';
import '../ui-searchinput/ui-searchinput.en';
import '../ui-signing/ui-signing.en';
import '../ui-skip-to-content/ui-skip-to-content.en';
import '../ui-slider/ui-slider.en';
import '../ui-slides/ui-slides.en';
import '../ui-stepper/ui-stepper.en';
import '../ui-table-cloneable/ui-table-cloneable.en';
import '../ui-table-expandable/ui-table-expandable.en';
import '../ui-table-sortable/ui-table-sortable.en';
import '../ui-tabs/ui-tabs.en';
import '../ui-textcounter/ui-textcounter.en';
import '../ui-timerange/ui-timerange.en';
import '../ui-tooltip/ui-tooltip.en';
import '../ui-upload-item/ui-upload-item.en';
import '../ui-upload/ui-upload.en';
import '../ui-video/ui-video.en';
import '../ui-wizard/ui-wizard.en';
import '../ui-asset/ui-asset.en';
import '../ui-slideview/ui-slideview.en';
import '../ui-rating/ui-rating.en';
import { Labels } from '../../shared-components/global/labels';
import { Language } from '../../shared-components/global/enums';

Labels.LANGUAGE = Language.English;

window.UI = { ...window.UI, Labels };
